// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep div.background {
  position: relative;
  width: 100%;
}
::ng-deep div.background:before {
  content: "";
  position: absolute;
  background-image: url("/assets/images/rooftop-solar-grid.jpeg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left top;
  width: 100%;
  height: 100%;
  min-height: 475px;
  z-index: 1;
}
::ng-deep ul.disc {
  list-style-type: disc;
  margin-bottom: 1rem;
}
::ng-deep ul.disc li {
  margin-left: 2rem;
  margin-bottom: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/residential-solar/residential-solar.component.scss"],"names":[],"mappings":"AACC;EACC,kBAAA;EACA,WAAA;AAAF;AAEE;EACC,WAAA;EACA,kBAAA;EACA,+DAAA;EACA,wBAAA;EACA,4BAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;AAAH;AAIC;EACC,qBAAA;EACA,mBAAA;AAFF;AAIE;EACC,iBAAA;EACA,qBAAA;AAFH","sourcesContent":["::ng-deep {\n\tdiv.background {\n\t\tposition: relative;\n\t\twidth: 100%;\n\n\t\t&:before {\n\t\t\tcontent:\"\";\n\t\t\tposition: absolute;\n\t\t\tbackground-image : url('/assets/images/rooftop-solar-grid.jpeg');\n\t\t\tbackground-size: contain;\n\t\t\tbackground-repeat: no-repeat;\n\t\t\tbackground-position: left top;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmin-height: 475px;\n\t\t\tz-index: 1;\n\t\t}\n\t}\n\n\tul.disc {\n\t\tlist-style-type: disc;\n\t\tmargin-bottom: 1rem;\n\n\t\tli {\n\t\t\tmargin-left: 2rem;\n\t\t\tmargin-bottom: .5rem;\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
